import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import {
  loadUserContactsStateSuccess,
  setContactConnectionStatus,
  setCurrentUserContactState,
  setIncomingCall,
} from '../actions';

export const connectContactsFeatureKey = 'contacts';

export interface ContactsState extends EntityState<IConnectContact> {
  selectedContactId?: string;
}

const connectionStatusPositions = Object.values(ConnectionStatus);

export const adapter: EntityAdapter<IConnectContact> =
  createEntityAdapter<IConnectContact>({
    selectId: (contact: IConnectContact) => contact.userId,
    sortComparer: (a: IConnectContact, b: IConnectContact) =>
      connectionStatusPositions.indexOf(a.connectionStatus) -
      connectionStatusPositions.indexOf(b.connectionStatus),
  });

export const contactsInitialState: ContactsState = adapter.getInitialState({});

export const contactsReducer = createReducer(
  contactsInitialState,
  on(
    loadUserContactsStateSuccess,
    (state, action): ContactsState =>
      adapter.setAll(action.contacts, { ...state }),
  ),
  on(
    setContactConnectionStatus,
    (state, { userId, status }): ContactsState =>
      adapter.updateOne(
        {
          id: userId,
          changes: {
            connectionStatus: status,
          },
        },
        state,
      ),
  ),
  on(
    setCurrentUserContactState,
    (state, { contact }): ContactsState => ({
      ...state,
      selectedContactId: contact.userId,
    }),
  ),
  on(
    setIncomingCall,
    (state, { incomingCall }): ContactsState => ({
      ...state,
      selectedContactId: incomingCall?.contact.userId,
    }),
  ),
);
